module.exports = __webpack_public_path__ + "static/images/txms-rights-interests-title.4e662db.png";